import React from 'react'
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
const PrivateRoute = ({component: Component, auth, ...rest}) => (
  <Route {...rest}
    render={props => auth.token !== '' ? !auth.userUpdated ? (<Redirect to="/recordatorio-actualizacion" />) : (
        //rest.roles.includes(auth.userRoles[0].toString().toLocaleLowerCase()) ? <Component {...props} /> : <Redirect to="/accesso-denegado" />
        rest.roles === '*' ? <Component {...props} /> : auth.userRoles.some(r => rest.roles.indexOf(r) >= 0) ? <Component {...props} /> : <Redirect to="/accesso-denegado" />
      ) : window.location.href = "/"
    }
  />
);
//(<Redirect to="/" />)
const mapStateToProps = state => ({
  auth: !!state.auth.token ? state.auth : localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : state.auth
});

export default connect(mapStateToProps)(PrivateRoute);